document.querySelector('.more').addEventListener('click', function() {
    this.style.display = 'none';
    document.querySelector('.less').classList.add('active');
    document.querySelector('.more-text').classList.add('active');
    
});

document.querySelector('.less').addEventListener('click', function() {
    this.classList.remove('active');
    document.querySelector('.more').style.display = 'inline';
    document.querySelector('.more-text').classList.remove('active');
});


document.addEventListener('DOMContentLoaded', function(event) {
    let output = document.querySelector('.wpcf7-response-output');
    let container = document.querySelector('.contact-form');
    if (output && container) {
      container.appendChild(output);
    }
  }, false);